import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1602"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.846 4.986c-1.84 1.244-5.034 1.205-8.687.428-3.463-.738-5.487.965-5.487.965 3.174-.072 5.856.939 8.208 1.386 5.569 1.059 5.966-2.779 5.966-2.779z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M13.194 8.568s-3.258 1.004-5.902-.415c-2.274-1.22-4.832-1.334-5.947-.738 0 0 1.736-.259 4.677 1.678 3.067 2.019 5.52.875 7.172-.525zM2.523 4.175c.021-.005 2.118-.222 3.713.274 1.045.327 1.907.489 2.618.489.567 0 1.039-.104 1.431-.31a2.038 2.038 0 0 0 1.013-1.23c.245-.791.136-1.565-.309-2.181S9.823.227 9.057.212a2.363 2.363 0 0 0-1.722.73.699.699 0 1 0 1.009.968.952.952 0 0 1 .688-.298c.316.006.64.173.822.426.186.256.221.574.105.945a.63.63 0 0 1-.325.407c-.292.154-1.068.321-2.981-.277-1.88-.586-4.186-.343-4.283-.33-.384.042-.66.388-.618.772s.39.644.771.62z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M12.759 10.516c-.728-.122-1.496.12-2.312.375-.507.159-1.032.323-1.564.407-2.42.387-4.915-1.957-4.94-1.98a.699.699 0 1 0-.97 1.009c.121.115 3.002 2.846 6.129 2.354.634-.1 1.234-.288 1.765-.454.652-.204 1.272-.394 1.661-.33.194.032.664.172.846.759a1.081 1.081 0 0 1-1.708 1.161.702.702 0 0 0-.984.107.701.701 0 0 0 .107.984 2.48 2.48 0 0 0 3.923-2.665c-.288-.925-1.017-1.57-1.953-1.727z" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }